// Module
var code = `<div sf-field-model="sf-new-array"
     sf-new-array
     class="form-group schema-form-checkboxes {{form.htmlClass}}"
     ng-class="{'has-error': form.disableErrorState !== true &&  hasError(), 'has-success': form.disableSuccessState !== true &&  hasSuccess()}">
  <label class="control-label {{form.labelHtmlClass}}"
         sf-field-model
         schema-validate="form"
         ng-show="showTitle()">{{form.title}}</label>

  <div class="checkbox" ng-repeat="val in titleMapValues track by \$index" >
    <label>
      <input type="checkbox"
             ng-disabled="form.readonly"
             sf-changed="form"
             class="{{form.fieldHtmlClass}}"
             ng-model="titleMapValues[\$index]"
             name="{{form.key.slice(-1)[0]}}">
      <span ng-bind-html="form.titleMap[\$index].name"></span>
    </label>

  </div>
  <div class="help-block" sf-message="form.description"></div>
</div>
`;
// Exports
module.exports = code;